export const formatCPF = (value) => {
    const onlyNums = value.replace(/\D/g, '');
    let formatted = onlyNums;
    if (onlyNums.length > 3) formatted = onlyNums.slice(0, 3) + '.' + onlyNums.slice(3);
    if (onlyNums.length > 6) formatted = formatted.slice(0, 7) + '.' + formatted.slice(7);
    if (onlyNums.length > 9) formatted = formatted.slice(0, 11) + '-' + formatted.slice(11, 13);
    return formatted;
};

export const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toISOString().split('T')[0];
};

export const mapGender = (gender) => {
    if (gender === 'Masculino') return 'M';
    if (gender === 'Feminino') return 'F';
    return null;
};

export const validateForm = (formData, fields) => {
    const fieldNames = fields.map(f => f.name);
    if (fieldNames.includes('cpf')) {
        const onlyNums = (formData.cpf || '').replace(/\D/g, '');
        if (onlyNums.length !== 11) return { valid: false, error: 'CPF inválido! Deve ter 11 dígitos.' };
    }
    if (fieldNames.includes('cb_pix')) {
        if (!formData.cb_pix || formData.cb_pix.length < 3) return { valid: false, error: 'Chave Pix inválida!' };
    }
    return { valid: true, error: '' };
};
